// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-area[data-v-354d35d8] {\n  width: 100%;\n  height: auto;\n  text-align: end;\n  padding-bottom: 8px;\n}\n.text[data-v-354d35d8] {\n  font-size: 14px;\n  color: #797979;\n}", ""]);
// Exports
module.exports = exports;
